import { useState, useEffect } from 'react'
import { RefreshCw } from 'lucide-react'

interface AppLoadingScreenProps {
  timeout?: number
  onRetry?: () => void
}

export function AppLoadingScreen({ timeout = 15000, onRetry }: AppLoadingScreenProps) {
  const [isTimedOut, setIsTimedOut] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsTimedOut(true), timeout)
    return () => clearTimeout(timer)
  }, [timeout])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface-secondary">
      <div className="animate-pulse mb-4">
        <img src="/favicon.svg" alt="" className="w-16 h-16 mx-auto" />
      </div>
      <h1 className="text-lg font-bold text-heading mb-3">
        To-Do List
      </h1>
      {isTimedOut ? (
        <div className="flex flex-col items-center gap-3">
          <p className="text-sm text-caption">로딩이 지연되고 있습니다</p>
          <button
            type="button"
            onClick={onRetry ?? (() => window.location.reload())}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            다시 시도
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-sm text-disabled">
          <div className="w-4 h-4 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
          <span>불러오는 중...</span>
        </div>
      )}
    </div>
  )
}
